
function ascendingSort(company1, company2) {
  const name1 = company1.name ? company1.name.toUpperCase() : '~';
  const name2 = company2.name ? company2.name.toUpperCase() : '~';
  const val = name1 === name2 ? 0 : -1;
  return name1 > name2 ? 1 : val;
}

const companyActions = {
  LOAD_COMPANY: 'LOAD_COMPANY',
  LOAD_COMPANY_SUCCESS: 'LOAD_COMPANY_SUCCESS',
  LOAD_COMPANY_ERROR: 'LOAD_COMPANY_ERROR',
  ADD_COMPANY: 'ADD_COMPANY',
  EDIT_COMPANY: 'EDIT_COMPANY',
  EDIT_COMPANY_VIEW: 'EDIT_COMPANY_VIEW',
  changeCompany: id => ({
    type: companyActions.CHANGE_COMPANY,
    id,
  }),
  loadCompany: data => (
    dispatch => (
      new Promise((resolve, reject) => {
        dispatch({
          type: companyActions.LOAD_COMPANY,
          payload: data,
          resolve,
          reject,
        });
      })
    )
  ),
  addCompany: newCompany => (dispatch) => {
    dispatch({
      type: companyActions.ADD_COMPANY,
      companies: [newCompany],
      selectedId: newCompany.id,
    });
  },
  editCompany: newCompany => (dispatch, getState) => {
    const companies = getState().Company.get('companies');
    const newCompanies = [];
    companies.forEach((company) => {
      if (company.id === newCompany.id) {
        newCompanies.push(newCompany);
      } else {
        newCompanies.push(company);
      }
    });
    dispatch({
      type: companyActions.EDIT_COMPANY,
      companies: newCompanies.sort(ascendingSort),
    });
  },
  editCompanyViewChange: view => (dispatch) => {
    dispatch({
      type: companyActions.EDIT_COMPANY_VIEW,
      view,
    });
  },

};
export default companyActions;



// WEBPACK FOOTER //
// ./src/redux/company/actions.js